import { render, staticRenderFns } from "./SectorSelector.vue?vue&type=template&id=039c5613&"
import script from "./SectorSelector.vue?vue&type=script&lang=js&"
export * from "./SectorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports